import { render, staticRenderFns } from "./TutorDashboardExpiredShiftTransferModal.vue?vue&type=template&id=20fa6d75&scoped=true&"
import script from "./TutorDashboardExpiredShiftTransferModal.vue?vue&type=script&lang=js&"
export * from "./TutorDashboardExpiredShiftTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./TutorDashboardExpiredShiftTransferModal.vue?vue&type=style&index=0&id=20fa6d75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fa6d75",
  null
  
)

export default component.exports